import React from "react";
import {
  LeftJustifiedInsuranceTermsLink,
  LeftJustifiedIpidLinks,
} from "../coverages.styles";

import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";

interface Props {
  product: ProductBackendName;
  cardIsSelected?: boolean;
  coverage: InsuranceCoverage;
  showExcludedCoverages?: boolean;
}

export const DittoCoverageCardDetailsOnlyTerms: React.FC<Props> = ({
  product,
  cardIsSelected,
  coverage,
}) => {
  return (
    <>
      <LeftJustifiedIpidLinks
        coverage={coverage}
        isOnColoredBackground={cardIsSelected}
      />
      <LeftJustifiedInsuranceTermsLink
        productBackendName={product}
        isOnColoredBackground={cardIsSelected}
      />
    </>
  );
};
